import styled from 'styled-components';

export const Bar = styled.div`
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    white-space: nowrap;
    color: white;
    font-size: 12px;
    font-weight: 500;
    line-height: 19px;
    padding: 4px 10px;
`;

export const IconWrapper = styled.span`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-top: -1px;
`;

export const ScreenShareIconWrapper = styled(IconWrapper)`
    background-color: ${({ theme }) => theme.root.colors.system.successDefault};
    border-radius: 4px;
    padding: 2px 4px;
`;

export const Name = styled.span`
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-shadow: 0px 0px 2px ${(props) => props.theme.root.colors.basicColors.black['24%']},
        0px 1px 2px ${(props) => props.theme.root.colors.basicColors['60%']};
`;
